<template>
  <b-container class="py-5 vh-100">
    <b-row class="h-100">
      <b-col md="2" class="text-center my-auto ml-auto">
        <div class="ml-auto">
          <p class="text-danger mb-0"><i class="fa fa-exclamation-triangle fa-5x"></i><br/></p>
          <b-button
            variant="outline-danger"
            class="text-uppercase"
            @click="$store.dispatch('auth/logout')"
          >
            {{$t($getConst.pages.settings.sign_out)}}
          </b-button>
        </div>
      </b-col>
      <b-col md="8" class="my-auto">
        <h3 class="text-capitalize">{{$t($getConst.pages.access_denied.access_denied_title)}}</h3>
        <p v-if="isFreelancer()">
          {{$t($getConst.pages.access_denied.freelancer_access_denied_description)}}
        </p>
        <template v-else>
          <p class="mb-0">{{$t($getConst.pages.access_denied.access_denied_description)}}.</p>
          <p>{{$t($getConst.pages.access_denied.available_scopes)}}:</p>
          <ul>
            <li v-for="scope in scopes">
              <b-link class="text-secondary" replace :href="scope">{{scope}}</b-link>
            </li>
          </ul>
        </template>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: "AppAccessDenied",
    props: {
      scopes: {
        type: Array,
        default: []
      }
    }
  }
</script>

<style scoped>

</style>
